<template>
  <div>
    <b-card title="Assuntos">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-subject-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
    <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        v-b-modal.update-api-cache-modal
      ><feather-icon icon="RefreshCwIcon" /> Atualizar Api Cache</b-button>

      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
    <b-modal
      ref="update-api-cache-modal"
      id="update-api-cache-modal"
      modal-class="modal-primary"
      title="Atualizar Api Cache"
      ok-title="Adicionar"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <b-row>
          <b-col md="12">
            <label for="sync-params-logical-number">Origem</label>
            <v-select
              id="sync-params-logical-number"
              placeholder="Selecione um numero logico"
              v-model="syncParamsForm.origin"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="origins"
              :tabindex="0"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-button
            class="btn-sm btn-nav-link btn-nav-link-white"
            size="sm"
            variant="flat-primary"
            :disabled="isSyncing"
            @click="updateApiCache"
          >
            <feather-icon v-if="!isSyncing" icon="RefreshCwIcon" />
            <b-spinner v-if="isSyncing" small />
            {{ isSyncing ? "Atualizando..." : "Atualizar" }}
          </b-button>
        </b-row>        
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BButton, BRow, BCol } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import subjectService from "@/providers/subjectService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from "@/providers/dropdownService";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    CustomGTable,
    vSelect,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      isSyncing: false,
      syncParamsForm: {
        origin: null
      },
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        // { field: "_id", label: "_id", sortable: false },
        { field: "code", label: "Código", sortable: false, filterOptions: { filterValue: '', enabled: true, numeric: true, placeholder: 'Pesquisar por código', trigger: 'enter' } },
        { field: "name", label: "Nome", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "acronym", label: "Sigla", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por sigla', trigger: 'enter' } },
        { field: "mnemonic", label: "Minemonico", sortable: false },
        { field: "origins", label: "Origem", type: "array", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "channels", label: "Canal", type: "array", sortable: false },
        // { field: "content", label: "Conteúdos", type: "array", sortable: false },
        // { field: "image_path", label: "Thumb", type: "thumb", sortable: false },
        // { field: "filter", label: "Filtro", sortable: false },
        // { field: "order", label: "Ordem", sortable: false, filterOptions: { enabled: true, placeholder: 'Pesquisar por ordem', trigger: 'enter' } },
        // { field: "public", label: "Público", type: "boolean", sortable: false },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Habilitado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        { field: "general", label: "Geral", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por geral', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        { field: "notSendInGeneral", label: "Não enviar no geral", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: '', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
      ],
      origins: [],
    };
  },
  mounted() {
    // console.log('route.query: ',this.$route.query);
    // console.log('props query: ',this.query);
    this.$store.dispatch("admin/updatePageTitle", 'Assuntos');
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    updateApiCache() {
      const params = new URLSearchParams();
      if (this.syncParamsForm.origin) {
        params.append('originCode', this.syncParamsForm.origin.code);
      }
      subjectService
        .updateApiCache(params)
        .then((response) => {
          this.isSyncing = false;
          console.log(response);
          this.$refs['update-api-cache-modal'].hide();
          messagesNotifyHelper.successNotify(
            "Api Cache",
            "Atualização feita com sucesso"
          );
        })
        .catch((err) => {
          this.isSyncing = false;
          console.log(err);
        });
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      subjectService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "assuntos.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      this.page = 1;
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          const origins = res.map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='origins')].filterOptions.filterDropdownItems = origins;
          this.syncParamsForm.origin = res.find(item => item.code == 250);
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_SUBJECT_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      subjectService
        .deleteSubject(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(() => {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', subjectService.getAllSubjects(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>